import { createUseStyles } from 'react-jss'

const useFormErrorStyles = createUseStyles({
  formError: {
    fontSize: 12,
    padding: '0.5rem 0',
    margin: 0,
    color: '#ff1c24'
  }
})

export { useFormErrorStyles }
